<template>
  <tooltip interactive>
    <template #default>
      <div
        class="rounded-full"
        :class="[
          canCall
            ? 'cursor-pointer bg-green-50 text-green-500 hover:bg-green-100'
            : 'bg-gray-100 text-gray-400',
          sizeClasses.circle,
        ]"
        @click="canCall && $emit('call')"
      >
        <div class="flex h-full items-center justify-center">
          <icon-base
            data-cy="telephoneIcon"
            :width="sizeClasses.icon"
            :height="sizeClasses.icon"
            view-box="0 0 16 16"
            :icon="IconTelephone"
            :icon-color="canCall ? 'currentColor' : '#C2C6CD'"
          />
        </div>
      </div>
    </template>
    <template #content>
      <telephone-tooltip-content class="flex items-center space-x-2">
        <span>
          {{ telephoneNumber }}
        </span>
      </telephone-tooltip-content>
    </template>
  </tooltip>
</template>

<script setup lang="ts">
import TelephoneTooltipContent from "@/components/communication/TelephoneTooltipContent.vue";
import IconTelephone from "@/components/icons/IconTelephone.vue";

defineEmits<{ call: [] }>();

type SizeOptions = {
  circle: string;
  icon: number;
};

const { sizeClasses = { circle: "size-[26px]", icon: 16 } } = defineProps<{
  canCall: boolean;
  telephoneNumber: string;
  sizeClasses?: SizeOptions;
}>();
</script>
